@if (position(); as pos) {
  <div
    class="premium-hint"
    role="dialog"
    aria-label="Stammgast"
    [style.left.px]="pos.left"
    [style.top.px]="pos.top"
    [style.bottom.px]="pos.bottom"
  >
    <button type="button" class="hint-close" aria-label="Schließen" (click)="close()">
      <i class="fas fa-xmark" aria-hidden="true"></i>
    </button>
    <p class="hint-title"><i class="fas fa-crown" aria-hidden="true"></i> Stammgast</p>
    <p class="hint-text">
      Die Krone tragen Spieler mit dem Stammtisch-Abo. Sie unterstützen schnapsen.online, damit es für alle
      kostenlos und werbefrei bleibt.
    </p>
    @if (inGame) {
      <a class="hint-link" href="/premium" target="_blank" rel="noopener" (click)="close()">
        Mehr erfahren <i class="fas fa-arrow-up-right-from-square" aria-hidden="true"></i>
      </a>
    } @else {
      <a class="hint-link" routerLink="/premium" (click)="close()">
        Mehr erfahren <i class="fas fa-arrow-right" aria-hidden="true"></i>
      </a>
    }
  </div>
}
